<template>
  <div class="toolbar p-3">
    <div class="btn-group mr-1">
      <c-button color="light"><c-icon name="cil-envelope-closed" /></c-button>
      <c-button color="light"><c-icon name="cil-star" /></c-button>
      <c-button color="light"><c-icon name="cil-bookmark" /></c-button>
    </div>
    <div class="btn-group mr-1">
      <c-button color="light"><c-icon name="cil-share" /></c-button>
      <c-button color="light"><c-icon name="cil-share-all" /></c-button>
      <c-button color="light"><c-icon name="cil-share-boxed" /></c-button>
    </div>
    <c-button color="light"><c-icon name="cil-trash" /></c-button>
    <label-dropdown />
    <div class="btn-group float-right">
      <c-button color="light"><c-icon name="cil-chevron-left" /></c-button>
      <c-button color="light"><c-icon name="cil-chevron-right" /></c-button>
    </div>
  </div>
</template>

<script>
import LabelDropdown from './LabelDropdown';

export default {
  name: 'MailToolbar',
  components: {
    LabelDropdown,
  },
};
</script>
